import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './article-group.scss.js';
import '../../atoms/buttons/enums.js';
import { getEllipsis } from '../../utilities/dom-helpers/index.js';

class ArticleGroup extends s {
    constructor() {
        super(...arguments);
        this._json = [];
        this.itemsPerPage = 10;
        this.removeLabel = 'All';
        this.pages = 1;
        this.currentPage = 1;
        this.uniqueLabels = [];
        this.tags = [];
        this.filter = '';
        this.filteredJson = [];
    }
    set json(value) {
        try {
            this._json = JSON.parse(value);
        }
        catch (e) {
            this._json = [];
            throw new Error(`Invalid JSON string provided to json property: ${e}`);
        }
        this.processJson();
    }
    get json() {
        return JSON.stringify(this._json);
    }
    processJson() {
        this.uniqueLabels = ArticleGroup.getUniqueLabels(this._json);
        this.tags = this.createTags(this.uniqueLabels);
    }
    firstUpdated() {
        if (this._json.length > 0) {
            this.processJson();
            this.handlePagination();
            this.uniqueLabels = ArticleGroup.getUniqueLabels(this._json);
            this.tags = this.createTags(this.uniqueLabels, true);
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('filter')) {
            const previousFilter = changedProperties.get('filter');
            if (previousFilter !== this.filter) {
                this.filterJson();
                this.requestUpdate('filteredJson');
                this.currentPage = 1;
            }
        }
        if (changedProperties.has('removeLabel') && this.removeLabel !== '') {
            this.tags = this.createTags(this.uniqueLabels, true);
        }
        if (changedProperties.has('removeLabel') && this.removeLabel === '') {
            this.tags = this.createTags(this.uniqueLabels, false);
        }
        if (changedProperties.has('pages')) {
            this.requestUpdate();
        }
        if (changedProperties.has('itemsPerPage')) {
            this.handlePagination();
            this.requestUpdate();
        }
    }
    static getUniqueLabels(data) {
        if (!Array.isArray(data) || !data)
            return [];
        return [...new Set(data.flatMap(item => item.Labels))];
    }
    createTags(labelsArray, reset = false) {
        if (!Array.isArray(labelsArray) || labelsArray.length === 0)
            return [];
        const resetTag = { title: this.removeLabel, active: true, link: '' };
        const tags = labelsArray.map(label => ({
            title: label,
            active: false,
            link: '',
        }));
        if (reset) {
            return [resetTag, ...tags];
        }
        return tags;
    }
    getCards(json) {
        if (!json || !Array.isArray(json))
            return [];
        return json.map((item) => this.generateCard(item));
    }
    handleTagSelected(event) {
        const selectedTag = event.detail;
        this.tags = this.tags.map(tag => (Object.assign(Object.assign({}, tag), { active: tag.title === selectedTag.title })));
        this.filter = selectedTag.title;
        this.currentPage = 1;
        this.filterJson();
    }
    filterJson() {
        let filteredData;
        if (this.filter === '' || this.filter === this.removeLabel) {
            filteredData = [...this._json];
        }
        else {
            filteredData = this._json.filter((item) => item.Labels.includes(this.filter));
        }
        this.pages = Math.ceil(filteredData.length / this.itemsPerPage);
        const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        this.filteredJson = filteredData.slice(startIndex, endIndex);
        this.requestUpdate('pages');
    }
    handlePagination() {
        const allEntries = this._json;
        if (!allEntries || !Array.isArray(allEntries) || allEntries.length === 0)
            return;
        const entriesAmmount = allEntries.length;
        this.pages = Math.ceil(entriesAmmount / this.itemsPerPage);
    }
    handlePageChange(event) {
        this.currentPage = event.detail.page;
        this.filterJson();
    }
    generateCard(item) {
        var _a, _b;
        const itemTags = this.createTags(item.Labels);
        const placeholder = 'https://www.convatec.com/_content/global-content/assets/images/fallbacks/card-gallery-block/BurgundyBasePlaceholder.jpg';
        const imageUrl = item.ImageUrl ? item.ImageUrl : placeholder;
        const ctaUrl = (_b = (_a = item.Cta) === null || _a === void 0 ? void 0 : _a.Url) !== null && _b !== void 0 ? _b : '';
        return x `<div class="grid-element"><simple-card ?isRtl="${false}" ?withBorder="${false}" padding="0" borderRadius="0.5em" additionalClasses="article-group-card" link="${ctaUrl}"><simple-image imageSrc="${imageUrl}" ?forceWideAspect="${true}" padding="0" borderRadius="0" marginBottom="0" additionalClasses="article-group-image" alt="${item.ImageAltText || ''}"></simple-image><div class="card-container"><div><description-text ?isRtl="${false}" fontSize="1em" marginBottom="0">${item.Date || ''}</description-text><title-text ?isRtl="${false}" fontSize="1.5em" marginBottom="0.5em">${item.Headline || ''}</title-text><description-text ?isRtl="${false}" fontSize="1.125em" marginBottom="1em">${getEllipsis(item.Body || '')}</description-text></div><filter-tags marginTop="0" marginBottom="0" justifyContent="center" .tagNames="${itemTags}"></filter-tags></div></simple-card></div>`;
    }
    render() {
        return x `<filter-tags .tagNames="${this.tags}" marginTop="1em" marginBottom="2em" justifyContent="center" _isAllTag="true" @tag-selected="${this.handleTagSelected}"></filter-tags><div class="article-group-container"><responsive-grid additionalClasses="article-group-grid">${this.getCards(this.filteredJson)}</responsive-grid><pagination-nav templateStyle="cvt" numberOfPages="${this.pages}" .currentPage="${this.currentPage}" @page-changed="${this.handlePageChange}"></pagination-nav></div>`;
    }
}
ArticleGroup.styles = css_248z;
__decorate([
    n({ type: String })
], ArticleGroup.prototype, "json", null);
__decorate([
    n({ type: Number })
], ArticleGroup.prototype, "itemsPerPage", void 0);
__decorate([
    n({ type: String })
], ArticleGroup.prototype, "removeLabel", void 0);
__decorate([
    n({ type: Number })
], ArticleGroup.prototype, "pages", void 0);
__decorate([
    t()
], ArticleGroup.prototype, "currentPage", void 0);
__decorate([
    t()
], ArticleGroup.prototype, "uniqueLabels", void 0);
__decorate([
    t()
], ArticleGroup.prototype, "tags", void 0);
__decorate([
    t()
], ArticleGroup.prototype, "filter", void 0);
__decorate([
    t()
], ArticleGroup.prototype, "filteredJson", void 0);
customElements.define('article-group', ArticleGroup);

export { ArticleGroup };
